/**
 * Halvard logo: a hexagonal crystal of ice, faceted, with ᚼ carved in: the Norse rune for hail,
 * which looks like a snowflake and is an H. Its edges are Brand's orange and Rime's teal.
 */
export function Logo({ size = 32, title = 'Halvard' }: { size?: number; title?: string | null }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role={title ? 'img' : undefined}
      aria-label={title ?? undefined}
      aria-hidden={title ? undefined : true}
    >
      <polygon points="32,4 56,18 56,46 32,60 8,46 8,18" fill="#D5E4EC" />
      <polygon points="32,4 56,18 32,32" fill="#F4F8FA" />
      <polygon points="8,18 32,4 32,32" fill="#E6EEF3" />
      <polygon points="8,46 8,18 32,32" fill="#C3D6E0" />
      <polygon points="56,46 32,60 32,32" fill="#AFC6D3" />
      <polyline
        points="8,46 8,18 32,4"
        fill="none"
        stroke="#E8742E"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <polyline
        points="32,60 56,46 56,18"
        fill="none"
        stroke="#0F6E73"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <g stroke="#28465A" strokeWidth="3.6" strokeLinecap="round">
        <line x1="32" y1="17" x2="32" y2="47" />
        <line x1="21" y1="23" x2="43" y2="41" />
        <line x1="43" y1="23" x2="21" y2="41" />
      </g>
    </svg>
  );
}

/** Logo and HALVARD wordmark. */
export function Brand({ size = 28 }: { size?: number }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <Logo size={size} title={null} />
      <span className="wordmark" style={{ fontSize: size * 0.68 }}>
        Halvard
      </span>
    </span>
  );
}
